import React from "react";
import { ActionCableProvider as ActionCableProviderBase } from "@thrash-industries/react-actioncable-provider"

const ActionCableProvider = (props) => {
  const API_WS_ROOT = process.env.REACT_APP_API_WS_ROOT;

  return <ActionCableProviderBase url={API_WS_ROOT} {...props} />
}

export default ActionCableProvider